import { useCallback, useLayoutEffect, useState } from "react"

import { Box, Dialog, Stack, Typography } from "@mui/material"
import { alpha } from "@mui/material/styles"
import dayjs from "dayjs"
import { useLocalStorage } from "usehooks-ts"

import { IconButton, SvgIcon, type FC } from ".."

const EmailModal: FC = () => {
  const [open, setOpen] = useState(false)
  const [emailSignupExpires, setEmailSignupExpires] = useLocalStorage("emailSignupExpires", "")

  const onClose = useCallback(() => setOpen(false), [])

  useLayoutEffect(() => {
    const now = dayjs()
    const expires = emailSignupExpires ? dayjs(emailSignupExpires) : null

    // Open the modal if it's storybook or if the email signup expires is not set or if it's expired
    if (process.env.STORYBOOK === "yes" || !expires || now.isAfter(expires)) {
      setEmailSignupExpires(now.add(72, "hour").toISOString())
      setTimeout(() => setOpen(true), process.env.STORYBOOK !== "yes" ? 10000 : 100)
    }
  }, [])

  return (
    <Dialog
      open={open}
      onClose={onClose}
      scroll="body"
      fullWidth
      slotProps={{
        backdrop: {
          sx: {
            bgcolor: (theme) => alpha(theme.palette["neutral.900"].main, 0.4),
          },
        },
      }}
      PaperProps={{
        elevation: 0,
        sx: {
          maxWidth: 960,
          borderRadius: 1.5,
          zIndex: 4100,
        },
      }}
      sx={{
        zIndex: 4000,
      }}
    >
      <Stack alignItems="flex-end" position="relative" p={5}>
        <IconButton
          variant="secondary"
          onClick={onClose}
          icon={<SvgIcon variant="x" size={16} />}
          sx={{
            width: { xs: 52 },
            height: { xs: 52 },
          }}
        />
      </Stack>

      <Box p={30} pt={5}>
        <Typography variant="heading.2xl" component="h3" mb={3}>
          {"Memories won't make themselves."}
        </Typography>
        <Typography variant="body.md" component="p">
          Unlock Insider Special Offers, Travel Inspiration, and Expert Guides.
        </Typography>
        <Box mt={{ xs: 10, lg: 15 }}>[[ INSERT FORM DATA HERE ]]</Box>
      </Box>
    </Dialog>
  )
}
export default EmailModal
